module.exports = {"name":"dna-linkblock-thurston"}


//////////////////
// WEBPACK FOOTER
// ./src/content/project.json
// module id = peJn
// module chunks = 1